import { createMemoStyles } from '@wds/styles';
import { PricingAppTheme } from '~app/styles/pricing/types';

export default createMemoStyles(({ palette, spacing }: PricingAppTheme) => ({
  AccordionContainer: {
    padding: 0,
    margin: 0,
    '&:not(:last-child)': {
      borderBottom: `1px solid ${palette.border.main}`,
    },
  },
  Collapsed: {
    display: 'none',
  },
  Trigger: {
    cursor: 'pointer',
    backgroundColor: palette.background.main,
    padding: [spacing[4], spacing[6], spacing[4], spacing[3]],
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
}));
